import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ShortLinkRedirect = () => {
  const { code } = useParams();

  useEffect(() => {
    // Redirect to backend which will handle the redirect and tracking
    // Using /api/s/ prefix for proper Kubernetes ingress routing
    window.location.href = `${API_URL}/api/s/${code}`;
  }, [code]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-zinc-400">Перенаправление...</p>
      </div>
    </div>
  );
};

export default ShortLinkRedirect;
